export const columns = [
  {
    title: "报价方案编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "方案总预算",
    width: 180,
    dataIndex: "totalBudget",
    key: "totalBudget",
	slots: { customRender: "totalBudget" },
  },
  {
    title: "方案负责人",
    width: 180,
    dataIndex: "responsibleTenantUserName",
    key: "responsibleTenantUserName",
  },
  {
    title: "备注",
    width: 300,
    dataIndex: "remark",
    key: "remark",
	slots: { customRender: "remark" },
  },
  {
    title: "最近更新时间",
    width: 200,
    dataIndex: "lastModifiedTime",
    key: "lastModifiedTime",
  },
  {
    title: "生效状态",
    width: 120,
    dataIndex: "validStatusName",
    key: "validStatusName",
  },
];
